module.exports = __webpack_public_path__ + "img/nvdaoshi.bf26814e.png";